/*
 * @Description: 网络请求
 * @Author: 琢磨先生
 * @Date: 2024-07-11 20:58:10
 * @LastEditors: 鱿鱼须 1519964028@qq.com
 * @LastEditTime: 2024-08-13 11:03:41
 */
import axios from 'axios'

import cfg from '@/config/config.js'
import { logout } from '@/api/operate/socket'
import { ElNotification, ElMessageBox, ElMessage, ElLoading } from 'element-plus'
import { blobValidate, errorCode, tansParams } from '@/plugins/assetBelong'
import { saveAs } from 'file-saver'

// const router = useRouter()
let config = {
	baseURL: cfg.HOST,
	timeout: 600000 //
}

const _axios = axios.create(config)

//请求开始时链接
_axios.interceptors.request.use(
	(config) => {
		//平台应用key
		config.headers.app = cfg.APP_KEY
		config.headers.platform = cfg.APP_PLATFORM

		//获取token
		const token = localStorage.getItem(cfg.TOKEN)
		if (token) {
			config.headers.Authorization = token
		}

		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

_axios.interceptors.response.use(
	async (response) => {
		if (response.config.responseType == 'blob') {
			return response.data
		}
		//未登录或已过期
		if (response.data.code == 9001) {
			localStorage.removeItem(cfg.TOKEN)
			localStorage.removeItem(cfg.USERINFO)
			localStorage.removeItem('menus')
			location.href = '/login'
			return Promise.reject('登录已过期')
		} else if (response.data.code == 9002) {
			ElMessage.error('用户未授权  - 没权限')
		} else if (response.data.code != 200) {
			// ElMessage.error(response.data.msg);
		}
		return response.data
	},
	(error) => {
		// var message = `网络请求错误，状态码：${error.response.status}`;
		// switch (error.response.status) {
		//   case 403:
		//     message = "没有权限，拒绝访问";
		//     break;
		// }
		// ElMessage.error(message);
		return Promise.reject(error)
	}
)

let downloadLoadingInstance
export function download(url, params, filename, config) {
	downloadLoadingInstance = ElLoading.service({
		text: '正在下载数据，请稍候',
		background: 'rgba(0, 0, 0, 0.7)'
	})
	return _axios
		.post(url, params, {
			transformRequest: [
				(params) => {
					return tansParams(params)
				}
			],
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			responseType: 'blob',
			...config
		})
		.then(async (data) => {
			const isBlob = blobValidate(data)
			if (isBlob) {
				const blob = new Blob([data])
				saveAs(blob, filename)
			} else {
				const resText = await data.text()
				const rspObj = JSON.parse(resText)
				const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
				if (rspObj.code == 200) {
					ElMessage.success(errMsg)
				} else {
					ElMessage.error(errMsg)
				}
			}
			downloadLoadingInstance.close()
		})
		.catch((r) => {
			console.error(r)
			ElMessage.error('下载文件出现错误，请联系管理员！')
			downloadLoadingInstance.close()
		})
}

export default _axios
